import { render } from "./platformAccount.vue?vue&type=template&id=7f953dd5"
import script from "./platformAccount.vue?vue&type=script&lang=js"
export * from "./platformAccount.vue?vue&type=script&lang=js"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__